
import PromptGrid from "@/components/prompts/PromptGrid";
import LoadingState from "@/components/explore/LoadingState";
import type { Prompt } from "@/services/promptService";

interface SearchResultsProps {
  isLoading: boolean;
  results: any[]; // Enhanced search results with additional fields
  searchQuery: string;
  hasCategory: boolean;
}

const SearchResults = ({ 
  isLoading, 
  results, 
  searchQuery,
  hasCategory
}: SearchResultsProps) => {
  if (isLoading) {
    return <LoadingState message={searchQuery ? "Searching prompts..." : "Loading prompts..."} />;
  }
  
  if (results.length > 0) {
    // Convert enhanced search results to Prompt format for PromptGrid
    const prompts: Prompt[] = results.map(result => ({
      id: result.id,
      title: result.title,
      description: result.description,
      content: result.content,
      category: result.category,
      category_id: result.category_id,
      likes: result.likes || 0,
      reviews: result.reviews || 0,
      copies: result.copies || 0,
      status: result.status || 'approved',
      author: result.author,
      createdAt: result.createdAt
    }));

    return (
      <>
        <p className="text-muted-foreground mb-6">
          Found {results.length} prompt{results.length !== 1 ? 's' : ''} 
          {searchQuery ? ` for "${searchQuery}"` : ''}
          {hasCategory ? ` in selected category` : ''}
        </p>
        <PromptGrid prompts={prompts} />
      </>
    );
  }
  
  return (
    <div className="text-center py-20">
      <h3 className="text-xl font-medium mb-2">No prompts found</h3>
      <p className="text-muted-foreground">
        {searchQuery || hasCategory ? 
          "Try adjusting your search terms or category filters." : 
          "No prompts are currently available."}
      </p>
    </div>
  );
};

export default SearchResults;
